import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function CourseCard({ c, light = false }) {
  const t = light ? "text-[#172A3A]" : "text-[#F5F2E9]";
  const sub = light ? "text-[#647080]" : "text-[#B9C0C9]";
  const bd = light ? "border-[#172A3A]/15 hover:border-[#BDA677] bg-white" : "border-[#2B4053] hover:border-[#BDA677] bg-[#1F3548]";
  return (
    <Link to={`/courses/${c.slug}`} data-testid={`course-card-${c.slug}`}
      className={`group flex flex-col border ${bd} p-6 sm:p-7 transition-[border-color,transform] duration-300 hover:-translate-y-0.5`}>
      <div className="flex items-center justify-between">
        <span className="font-mono text-[12px] tracking-[0.18em] text-[#9C8556]">{c.code}</span>
        <span className={`text-[10.5px] uppercase tracking-[0.16em] ${sub}`}>{c.faculty ? `Independent ${c.tuition} · Faculty-led ${c.faculty.tuition}` : `Self-paced · ${c.tuition}`}</span>
      </div>
      <h3 className={`font-academic ${t} text-[26px] leading-[1.1] font-semibold mt-4`}>{c.title}</h3>
      <p className={`${sub} text-[11px] uppercase tracking-[0.14em] mt-2`}>{c.level}</p>
      <p className={`${sub} text-sm leading-relaxed mt-4 flex-1`}>{c.description}</p>
      <div className={`mt-6 pt-4 border-t ${light ? "border-[#172A3A]/10" : "border-[#2B4053]"} flex items-center justify-between text-[12px] ${sub}`}>
        <span>{c.status} · {c.reading_count} required readings</span>
        <ArrowUpRight size={16} className="text-[#BDA677] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </Link>
  );
}
